import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { ApplicationList } from './ApplicationList';

export const AdminApplications = () => {
    const navigate = useNavigate();

    const handleCreateApplication = () => {
        navigate('/admin/applications/create');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100%',
                height: '100%',
            }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 3, pb: 2 }}>
                <Typography variant="h5">Applications</Typography>
                <Button variant="contained" onClick={handleCreateApplication}>
                    Create Application
                </Button>
            </Box>
            <Divider />
            <ApplicationList />
        </Box>
    );
};
